// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"37edaaef","401":"894c5392","526":"62aac1f4","562":"9346bef3","649":"9062f238","672":"e3f9bd2f","825":"e97aab67","855":"454a5d01"}[chunkId] + ".chunk.css";
};